// extracted by mini-css-extract-plugin
export var cardIcon = "_62-5";
export var cardIconUnframed = "_62-9";
export var checkboxCard = "_62-0";
export var checkboxCardSelected = "_62-4";
export var disabled = "_62-2";
export var interactive = "_62-1";
export var outerBorder = "_62-3";
export var spacerMedium = "_62-8";
export var spacerSmall = "_62-7";
export var spacerXsmall = "_62-6";